import React from "react";
import ReactPlayer from "react-player";

const VideosInfo = (props) => {
  return (
    <div className="card">
      <h3>Video</h3>
      <div className="card-body">
        <div className="update-images-div">
          {(props.data?.uncommonNewData?.videoOne ||
            props.data?.uncommonNewData?.videoOneTitle) && (
            <div className="video-box">
              <ReactPlayer
                controls={true}
                muted
                url={props.data?.uncommonNewData?.videoOne}
              />
              <label>{props.data?.uncommonNewData?.videoOneTitle}</label>
            </div>
          )}
          {(props.data?.uncommonNewData?.videoTwo ||
            props.data?.uncommonNewData?.videoTwoTitle) && (
            <div className="video-box">
              <ReactPlayer
                controls={true}
                muted
                url={props.data?.uncommonNewData?.videoTwo}
              />
              <label>{props.data?.uncommonNewData?.videoTwoTitle}</label>
            </div>
          )}
          {(props.data?.uncommonNewData?.videoThree ||
            props.data?.uncommonNewData?.videoThreeTitle) && (
            <div className="video-box">
              <ReactPlayer
                controls={true}
                muted
                url={props.data?.uncommonNewData?.videoThree}
              />
              <label>{props.data?.uncommonNewData?.videoThreeTitle}</label>
            </div>
          )}
          {(props.data?.uncommonNewData?.videoFour ||
            props.data?.uncommonNewData?.videoFourTitle) && (
            <div className="video-box">
              <ReactPlayer
                controls={true}
                muted
                url={props.data?.uncommonNewData?.videoFour}
              />
              <label>{props.data?.uncommonNewData?.videoFourTitle}</label>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VideosInfo;
